import { ParentBase, ParentId, SelectOptionType } from 'types';
import { getFullName } from 'utils/getFullName';

export const parseParentBaseIntoSelectOptionType: (
    parent: ParentBase,
) => SelectOptionType<ParentId, string> = (parent) => ({
    label: getFullName(parent.firstName, parent.lastName),
    value: parent.id,
});
